import { RefObject, useCallback, useEffect, useRef } from 'react'
import { useScreenshot } from './lib/ctx'

export const useLoadScreenshot = ({
  componentRef,
  width = 392,
  retry,
  delay,
  googleFonts = [],
}: {
  componentRef: RefObject<HTMLDivElement>
  width: number
  retry?: number
  delay?: number
  googleFonts?: string[]
}) => {
  const takeScreenshot = useScreenshot((s) => s.takeScreenshot)
  const loaded = useRef(false)

  const load = useCallback(async () => {
    if (componentRef.current) {
      await takeScreenshot({
        component: componentRef.current,
        options: {
          cacheBust: true,
          width: width,
          googleFonts,
        },
        retry,
        delay,
      })
    }
  }, [takeScreenshot, googleFonts, width, retry, delay, componentRef])

  useEffect(() => {
    if (!loaded.current) {
      load()
      loaded.current = true
    }
  }, [load])
}
